import { Component, OnInit } from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {OptInSettings} from '../../../model';
import {OrgIdService} from '../../../services';
import {OptInService} from '../../../services/opt-in.service';

@Component({
  selector: 'app-sms-privacy-policy',
  templateUrl: './sms-privacy-policy.component.html',
  styleUrls: ['./sms-privacy-policy.component.css']
})
export class SmsPrivacyPolicyComponent implements OnInit {
  optInSettings$: Observable<OptInSettings | null>;
  orgId: string;
  currentYear: number;

  constructor(
    private orgIdService: OrgIdService,
    private optInService: OptInService,
  ) {
    const date = new Date();
    this.currentYear = date.getFullYear();
    this.orgId = this.orgIdService.getOrgId();
    this.optInSettings$ = new BehaviorSubject<OptInSettings | null>(null);
  }

  ngOnInit() {
    // Get org ID from route params
    this.orgId = this.orgIdService.getOrgId();
    console.log('Org id is', this.orgId);

    this.optInSettings$ = this.optInService.loadForOrg(this.orgId);
  }
}
